export const errorMessages = {
  invalid_password: 'Votre mot de passe est invalide ou pas assez fort. Essayez d\'utiliser des symboles, des majuscules, des minuscules et des chiffres.',
  password_not_match: 'Les mots de passe ne correspondent pas. Assurez-vous d\'avoir tapé le même mot de passe dans les deux champs.'
};
